module.exports = __webpack_public_path__ + "img/stripeimg.9fdae676.jpg";